export const MembershipIds = {
  TRANSFERRED: 'transferredPlan',
  ANNUAL: 'yearlyPlanC',
  MONTHLY: 'fightcampplanC',
  SIX_MONTHS: '6MonthsPlan5',
  GQ: 'GQfightcampplan',
  PT: 'partnerfightcampplan',
  ANNUAL_390_DEV: 'price_1RoYcsBHlto6ebSHoNTZyr7P',
  ANNUAL_390_PROD: 'price_1RoZayBHlto6ebSHGoQF8oY9',
}